import React from 'react';
import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import particlesConfig from '../../Shared/pr-s-black';
import '../../Assets/Stylesheets/Pages/Platforms/Shopify_p.scss';

export default function Shopify() {
  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  return (
    <div className="shopify-page">
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={particlesConfig}
        className="particles-background"
      />
      <div className="shopify-content">
        <h1>Shopify Marketing Platform</h1>
        
        <section className="shopify-section">
          <h2>Transform Your E-commerce Business</h2>
          <p>Shopify is the leading e-commerce platform powering over 1.7 million businesses worldwide, offering comprehensive tools to market, sell, and grow your online store.</p>
        </section>

        <section className="shopify-section">
          <h2>Key Marketing Features</h2>
          <div className="features-grid">
            <div className="feature-item">
              <h3>Marketing Automation</h3>
              <p>Automate your marketing campaigns, email sequences, and customer communications to drive sales and engagement.</p>
            </div>
            <div className="feature-item">
              <h3>SEO & Content Marketing</h3>
              <p>Built-in SEO tools and blogging capabilities to improve your store's visibility and attract organic traffic.</p>
            </div>
            <div className="feature-item">
              <h3>Social Media Integration</h3>
              <p>Seamlessly connect your store with social media platforms for multi-channel selling and marketing.</p>
            </div>
            <div className="feature-item">
              <h3>Analytics & Reporting</h3>
              <p>Comprehensive analytics dashboard to track sales, customer behavior, and marketing campaign performance.</p>
            </div>
          </div>
        </section>

        <section className="shopify-section">
          <h2>Why Choose Shopify?</h2>
          <ul className="benefits-list">
            <li>All-in-one e-commerce solution</li>
            <li>Powerful marketing tools and integrations</li>
            <li>Mobile-first platform design</li>
            <li>Secure payment processing</li>
            <li>24/7 customer support and resources</li>
          </ul>
        </section>
      </div>
    </div>
  );
}
